import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function ReportLoadingCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Loading report…</CardTitle>
        <CardDescription>Fetching details and steps.</CardDescription>
      </CardHeader>
    </Card>
  );
}
